

export default function Dashboard() {
    return (
        <div>
            Dashboard page
        </div>
    );
}
